module.exports = __webpack_public_path__ + "assets/retina_Secant2Detailed.5c1debedd94a3c49ea3b09f35c8f4d06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Secant2Detailed.png
// module id = 711
// module chunks = 0